<template>

  <div class="app_cp">
    <div class="gujiap">
      <p><span @click="back()">产品信息</span> > <span style="color: rgb(41 76 177)">商品详情</span></p>
    </div>
    <div class="detailshead">
      <div class="boximg">
        <img :src="str1[0].img" alt="">
      </div>
      <div class="boxtext">
        <h2>{{str1[0].commodityName}}</h2>
        <div class="boxdec" v-if="str1[0].title == '商品说明书'">
          <div>
            <p>批准文号：{{str1[0].commodityApproval}}</p>
            <p>剂型：{{str1[0].commodityMeter}}</p>
          </div>
          <div>
            <p>生产厂家：{{ str1[0].commoditymanufactor }}</p>
            <p>有效期至：{{str1[0].commodityTime}}</p>
          </div>
        </div>
        <div class="boxdec" v-else>
          <div class="left">
            <p>产品名称: {{ str1[0].name }}</p>
            <p>规格/型号: {{ str1[0].unit }}</p>
            <p>适用范围: {{ str1[0].range }}</p>
          </div>
          <div class="right">
            <p>注册账号/备案凭证号: {{ str1[0].recordNumber }}</p>
            <p>注册人/生产企业: {{ str1[0].register }}</p>
          </div>
        </div>
        <div class="clickImg">
          <div v-for="(item,index) in str1[0].imgList" :key="index">
            <img :src="item.src" alt="" @click="checkimg(index)">
          </div>
        </div>
      </div>
    </div>
    <div class="detailsbody">
      <div class="detailsbodysms">
        <div>
          {{ str1[0].title }}
        </div>
      </div>
      <div>
        <img style="width: 900px;" :src="str1[0].commodityImg" alt="">
      </div>
    </div>

  </div>

</template>

<script setup>
import { useRoute,useRouter } from 'vue-router';
import { onBeforeMount, reactive } from 'vue';
const route = useRoute();
const router = useRouter();

let str = reactive({
  list: [{
    id: "xg",
    title: '商品说明书',
    commodityName: "桂林西瓜霜",
    commodityApproval: "国药准字Z45021599",
    commoditymanufactor: "桂林三金药业股份有限公司",
    commodityMeter: "喷剂",
    commodityTime: "2026.01",
    commodityImg: require("@/assets/details/a2glxgs.png"),
    img: require("@/assets/details/detailsfont/xg1.png"),
    imgList: [
      { src: require("@/assets/details/detailsfont/xg1.png") },
      { src: require("@/assets/details/detailsfont/xg2.png") },
      { src: require("@/assets/details/detailsfont/xg3.png") }
    ]
  },{
    id: "cy",
    title: '商品说明书',
    commodityName: "肠炎宁片",
    commodityApproval: "国药准字Z36020518",
    commoditymanufactor: "江西康恩贝中药有限公司",
    commodityMeter: "片剂",
    commodityTime: "2027.08",
    commodityImg: require("@/assets/details/a5cylp.png"),
    img: require("@/assets/details/detailsfont/cyn1.png"),
    imgList: [
      { src: require("@/assets/details/detailsfont/cyn1.png") }
    ]
  }, {
    id: "gm",
    title: '商品说明书',
    commodityName: "感冒灵颗粒",
    commodityApproval: "国药准字Z44021940",
    commoditymanufactor: "华润三九医药股份有限公司",
    commodityMeter: "颗粒剂",
    commodityTime: "2026.11",
    commodityImg: require("@/assets/home/gm/sms.png"),
    img: require("@/assets/home/gm/home.jpg"),
    imgList: [
      { src: require("@/assets/home/gm/home.jpg") },
      { src: require("@/assets/home/gm/1.jpg") },
    ]
  }, {
    id: "rs",
    title: '商品说明书',
    commodityName: "乳酸菌素片",
    commodityApproval: "国药准字H20059905",
    commoditymanufactor: "江中药业股份有限公司",
    commodityMeter: "片剂",
    commodityTime: "2026.01",
    commodityImg: require("@/assets/home/rs/sms.png"),
    img: require("@/assets/home/rs/home.jpg"),
    imgList: [
      { src: require("@/assets/home/rs/home.jpg") },
      { src: require("@/assets/home/rs/1.jpg") },
      { src: require("@/assets/home/rs/2.jpg") },
    ]
  }, {
    id: "xyj",
    title: '注册证',
    commodityName: "电子血压计(欧姆龙)",
    name: "电子血压计",
    unit: "HEM-7121",
    range: "用于测量成人血压及脉搏数",
    recordNumber: "辽械注准 20162070146",
    register: "欧姆龙(大连)有限公司",
    commodityImg: require("@/assets/details/detailsfont/xyj-sms.png"),
    img: require("@/assets/details/detailsfont/xyj.png"),
    imgList: [
      { src: require("@/assets/details/detailsfont/xyj.png") }
    ]
  }, {
    id: "xty",
    title: '注册证',
    commodityName: "血糖仪",
    name: "血糖仪",
    unit: "305A",
    range: "与江苏鱼跃医疗设备股份有限公司生产的鱼跃血糖试纸配套，用于医院和家庭检测毛细血管全血或静脉全血中的葡萄糖浓度。",
    recordNumber: "苏械注准20172220309",
    register: "江苏鱼跃医疗设备股份有限公司",
    commodityImg: require("@/assets/details/detailsfont/xty-sms.png"),
    img: require("@/assets/details/detailsfont/xty.jpg"),
    imgList: [
      { src: require("@/assets/details/detailsfont/xty.jpg") }
    ]
  }],
})
let str1 = reactive([])

onBeforeMount(() => {
  str.list.forEach((item) => {
    if (item.id == route.query.id) {
      str1.push(item)
    }
  })
})
function checkimg (index) {
  str1[0].imgList.forEach((item, ind) => {
    if (index == ind) {
      str1[0].img = item.src
    }
  })
}
function back(){
  router.push({
    path: `/commodity`
  })
}

</script>

<style scoped lang="less">
.app_cp {
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  .gujiap {
    width: 100%;
    height: 35px;
    background: #f5f5f5;
    margin-bottom: 20px;
    p{
       margin-left: 70px;
    }
    p:hover{
      cursor: pointer;
    }
  }
  .detailshead {
    display: inline-block;
    display: flex;
    .boximg {
      width: 290px;
      height: 290px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      border: 1px solid #d9d9d9;
    }
    img {
      width: 191px;
      height: 231px;
      transition: all 0.3s ease;
    }
    img:hover {
      transform: scale(1.1);
    }
    .boxtext {
      height: 290px;
      width: 881px;
      margin-left: 30px;
      .boxdec {
        height: 154px;
        margin: 40px 0px 70px 0px;
        display: flex;
        background: #f8f8f8;
        p {
          margin: 20px 120px 0px 10px;
        }
        .left {
          flex: 1.2;
        }
        .right {
          flex: 1;
        }
      }
      .clickImg {
        width: 150px;
        height: 50px;
        display: flex;
        align-items: center;
        div {
          display: flex;
          margin: 0px 10px;
          border: 1px solid #d9d9d9;
        }
        div:hover {
          border: 1px solid #666666;
        }
        img {
          width: 40px;
          height: 40px;
        }
        img:hover {
          transform: scale(1);
        }
      }
    }
  }
  .detailsbody {
    margin: 20px 0px;
    .detailsbodysms {
      width: 1242px;
      height: 40px;
      margin-bottom: 20px;
      background: #f1f2f4;
      border: 1px solid #eeeeee;
      div {
        width: 99px;
        height: 41px;
        color: #1ab580;
        line-height: 41px;
        text-align: center;
        border-top: 2px solid #1ab580;
        background: #ffffff;
      }
    }
  }
}
</style>
